// ============================================================
// rendu.js — le texte de l'assistant en blocs SOBRES, sans HTML.
// ------------------------------------------------------------
// Pas de bibliothèque markdown, et surtout pas de `innerHTML` : la réponse
// vient d'un modèle qui a lu des mails d'inconnus. On reconnaît quatre
// choses — paragraphes, listes, **gras**, titres — et deux sortes de
// références, rendues en liens : un devis (2026-10-013) et une pièce
// (« pièce n° 228 »). Tout le reste est du texte.
// ============================================================

const REF_DEVIS = /\b(20\d{2}-\d{2}-\d{3}(?:-[A-Z])?)\b/;
const REF_PIECE = /\bpi[eè]ce n[°o]\s?(\d+)\b/i;
const GRAS = /\*\*([^*]+)\*\*/;

/** Une ligne → des morceaux : texte, gras, lien devis, lien pièce. */
export function morceaux(ligne) {
  const sortie = [];
  let reste = String(ligne ?? '');
  while (reste) {
    const candidats = [
      ['gras', GRAS.exec(reste)], ['devis', REF_DEVIS.exec(reste)], ['piece', REF_PIECE.exec(reste)],
    ].filter(([, m]) => m);
    if (!candidats.length) {
      sortie.push({ type: 'texte', valeur: reste });
      break;
    }
    const [type, m] = candidats.sort((a, b) => a[1].index - b[1].index)[0];
    if (m.index > 0) sortie.push({ type: 'texte', valeur: reste.slice(0, m.index) });
    if (type === 'gras') sortie.push({ type: 'gras', valeur: m[1] });
    else if (type === 'devis') sortie.push({ type: 'devis', valeur: m[1], cible: m[1] });
    else sortie.push({ type: 'piece', valeur: m[0], cible: m[1] });
    reste = reste.slice(m.index + m[0].length);
  }
  return sortie;
}

/** Le texte → des blocs : paragraphe, liste (à puces ou numérotée), titre. */
export function blocs(texte) {
  const sortie = [];
  let liste = null;
  for (const brute of String(texte ?? '').split('\n')) {
    const ligne = brute.trimEnd();
    const puce = /^\s*(?:[-*•]|\d+[.)])\s+(.*)$/.exec(ligne);
    if (puce) {
      const ordonnee = /^\s*\d/.test(ligne);
      if (!liste || liste.ordonnee !== ordonnee) {
        liste = { type: 'liste', ordonnee, items: [] };
        sortie.push(liste);
      }
      liste.items.push(morceaux(puce[1]));
      continue;
    }
    liste = null;
    // Une ligne de séparation (« --- ») n'est pas du contenu.
    if (!ligne.trim() || /^\s*([-*_])\1{2,}\s*$/.test(ligne)) continue;
    const titre = /^#{1,6}\s+(.*)$/.exec(ligne);
    if (titre) sortie.push({ type: 'titre', morceaux: morceaux(titre[1]) });
    else sortie.push({ type: 'paragraphe', morceaux: morceaux(ligne) });
  }
  return sortie;
}
